/* 布局 */
//前台
import Layout from "@views/layout";

const tombstonetemplateRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "tombstonetemplate/list",
        name: "TOMBSTONETEMPLATE",
        meta: {
            title: "墓碑模板管理",
            keepAlive:true
        },
        component: () => import("@views/business/tombstonetemplate/index.vue"),
    },
        ],
};

export default tombstonetemplateRouter;
